export default "__VITE_ASSET__f738fb83__"